import { useEffect, useState, useRef } from "react";
import axios from "axios";
import { SERVER_URL } from "../../databucket";
import { AntdButton } from "../../blueplanitUtils/InputField";
import { S3ACCESSURL } from "../../databucket";
import { useDispatch } from "react-redux";
import { setLoader } from "../../Slices/loaderSlice";
import { Modal, message } from 'antd';

export const FileUploadPreview = () => {
  const [file, setFile] = useState(null);
  const [fileURL, setFileURL] = useState("");
  const [btnStatus, setBtnStatus] = useState(true);
  const [fileInfo, setFileInfo] = useState(null); // Stores filename/type if fetched from backend
  const [filesList, setFilesList] = useState([]); // Instead of single fileURL/fileInfo

  const fileInputRef = useRef();
  const dispatch = useDispatch();
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;
    setFile(selectedFile);
    setFileURL(URL.createObjectURL(selectedFile));
    setFileInfo({
      name: selectedFile.name,
      type: selectedFile.type,
    });
    setBtnStatus(false);
  };

  const handleSubmit = async () => {
    if (!file) return;

    const formData = new FormData();
    formData.append("files", file);

    try {
      dispatch(setLoader(true));

      // Upload the file
      try{
      const res = await axios.post(`${SERVER_URL}/upload`, formData);
     
      const uploadedFile = res.data.files[0];
      await axios.post(`${SERVER_URL}/api/fileURL`, {
        url: uploadedFile.url,
        filename: uploadedFile.originalName,
      });

      await fetchFileURL();

      handleRemove();
      setBtnStatus(true);
      dispatch(setLoader(false));
       }
      catch (error) {
        dispatch(setLoader(false));
    if (error.response && error.response.status === 413) {
      message.error({
        content:'File is too large. Please upload smaller files.'
      })

    } else {
      message.error({
        content:'Upload failed. Please try again.'
      })
      
    }
  }
    } catch (error) {
      dispatch(setLoader(false));
    }
  };

  const fetchFileURL = async () => {
    try {
      dispatch(setLoader(true));
      const res = await axios.get(`${SERVER_URL}/api/FetchAllfileURL`);
      const fetchedFiles = res.data;

      const mappedFiles = fetchedFiles.map((file, index) => ({
        _id: file._id,
        url: S3ACCESSURL + file.url,
        name: file.filename,
        status: file.status !== undefined ? file.status : (index === 0), // default true/false
        type: file.filename.endsWith(".pdf")
          ? "application/pdf"
          : file.filename.endsWith(".csv")
            ? "text/csv"
            : "image/*",
        deleted: false,
      }));

      setFilesList(mappedFiles);
      dispatch(setLoader(false));
    } catch (error) {
    } finally {
      dispatch(setLoader(false));
    }
  };

  // Delete file
  const deleteFile = async (id) => {
    try {
      dispatch(setLoader(true));
      await axios.patch(`${SERVER_URL}/api/fileDelete/${id}`);
      setFilesList(filesList.map(f =>
        f._id === id ? { ...f, deleted: true } : f
      ));
      dispatch(setLoader(false));
    } catch (err) {
      dispatch(setLoader(false));
    }
  };


  const handleStatusChange = async (file, newStatus) => {
    if (newStatus === "flag") {
      if (file.status) {
        message.warning("You cannot delete the active file. Please deactivate it first.");
        return;
      }
      Modal.confirm({
        title: "Delete File",
        content: `Are you sure you want to delete "${file.name}"?`,
        okText: "Yes",
        cancelText: "No",
        onOk: async () => {
          try {
            dispatch(setLoader(true));
            await deleteFile(file._id);
            message.success("File deleted successfully");
            dispatch(setLoader(false));
          } catch (err) {
            message.error("Failed to delete file");
            dispatch(setLoader(false));
          }
        }
      });
    } else {
      Modal.confirm({
        title: "Change File Status",
        content: `Do you want to mark "${file.name}" as ${newStatus === "true" ? 'Active' : 'Inactive'}?`,
        okText: "Yes",
        cancelText: "No",
        onOk: async () => {
          try {
            dispatch(setLoader(true));
            await axios.patch(`${SERVER_URL}/api/fileStatus/${file._id}`, { status: newStatus === "true" });
            await fetchFileURL();
            message.success("Status updated successfully");
            dispatch(setLoader(false));
          } catch (err) {
            message.error("Failed to update status");
            dispatch(setLoader(false));
          }
        }
      });
    }
  };

  useEffect(() => {
    fetchFileURL();
  }, []);

  const handleRemove = () => {
    setFile(null);
    setFileURL("");
    setFileInfo(null);
    setBtnStatus(true);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  // Determine file type for preview
  const fileType = file?.type || fileInfo?.type;
  const fileName = file?.name || fileInfo?.name;

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <div className="card p-4 shadow-sm">
          <h3 className="mb-3">Upload File</h3>

          <div className="d-flex align-items-center gap-2 mb-3">
            <input
              type="file"
              className="form-control"
              onChange={handleFileChange}
              style={{ maxWidth: "30%", maxHeight: "32px", padding: "4px 8px", textAlign: "center", }}
              ref={fileInputRef}
            />
            <>
              <AntdButton type="primary" label="Submit" disabled={btnStatus} onClick={handleSubmit} />
              <AntdButton type="default" danger label="Cancel" disabled={btnStatus} onClick={handleRemove} />
            </>
          </div>
          {filesList.filter(file => !file.deleted).length > 0 && (
            <div className="mt-3">
              <h5 className="mb-3 text-start">All Uploaded Files</h5>
              <div className="d-flex flex-wrap gap-3 justify-content-start">
                {filesList.filter(file => !file.deleted).map((file, idx) => (
                  <div
                    key={idx}
                    className="border rounded p-2 shadow-sm d-flex flex-column position-relative"
                    style={{
                      width: '180px',
                      height: '260px',
                      gap: '8px',
                      opacity: file.status ? 1 : 0.6,
                      borderColor: file.status ? "#007bff" : "#ccc",
                      backgroundColor: file.status ? "#fff" : "#f8f9fa",
                    }}
                  >
                    {/* Delete Cross Icon */}
                    <button
                      onClick={() => handleStatusChange(file, "flag")}
                      style={{
                        position: "absolute",
                        top: "-5px",
                        right: "-10px",
                        border: "none",
                        background: "transparent",
                        cursor: "pointer",
                        fontSize: "20px",
                        color: "red",
                        fontWeight: "bold",
                      }}
                      title="Delete File"
                    >
                      ×
                    </button>

                    {/* File Name clickable */}
                    <a
                      href={file.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="fw-bold text-decoration-none"
                      style={{
                        color: '#0d6efd',
                        wordBreak: 'break-word',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        width: '100%',
                        paddingRight: '20px'
                      }}
                      title={file.name}
                    >
                      {file.name}
                    </a>

                    {/* File Preview container */}
                    <div style={{ flexGrow: 1, overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      {file.type?.startsWith("image/") && (
                        <img
                          src={file.url}
                          alt={file.name}
                          className="img-fluid rounded"
                          style={{ maxHeight: "100px", objectFit: 'cover', width: '100%' }}
                        />
                      )}
                      {file.type === "application/pdf" && (
                        <iframe
                          src={file.url}
                          title={file.name}
                          width="100%"
                          height="100px"
                          className="border rounded"
                        ></iframe>
                      )}
                      {file.type === "text/csv" && (
                        <a
                          href={file.url}
                          className="btn btn-sm btn-outline-primary"
                          download={file.name}
                        >
                          Download CSV
                        </a>
                      )}
                      {!file.type?.startsWith("image/") &&
                        file.type !== "application/pdf" &&
                        file.type !== "text/csv" && (
                          <a
                            href={file.url}
                            className="btn btn-sm btn-outline-primary"
                            download={file.name}
                          >
                            Download
                          </a>
                        )}
                    </div>
                    {/* Activate / Deactivate Buttons */}
                    <div className="d-flex gap-1 justify-content-center">
                      <AntdButton
                        type="primary"
                        onClick={() => handleStatusChange(file, "true")}
                        disabled={file.status}
                        label="Activate"
                        style={{ maxWidth: "40%" }}
                      />
                      <AntdButton
                        type={file.status ? "primary" : "default"}
                        onClick={() => handleStatusChange(file, "false")}
                        disabled={!file.status}
                        label="Deactivate"
                        style={{ maxWidth: "50%" }}
                      />
                    </div>
                  </div>
                ))}

              </div>
            </div>

          )}



        </div>
      </div>
    </div>
  );
};

export default FileUploadPreview;
